<template>
<v-layout align-center justify-center>
    <v-flex xs12 sm12 md12 lg12 xl9>
      <v-card>
        <progress-bar :show="form.busy||isLoading"></progress-bar>
        <form @submit.prevent="editAssembly" @keydown="form.onKeydown($event)">
          <v-card-title primary-title>
            <h3 class="headline mb-0">{{ $t('assembly.edit-form.title') }}</h3>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 md5 lg5>
                  <select-input
                    :form="form"
                    :label="$t('assembly.create-form.assembly_type')"
                    :items="assembly_types"
                    :v-errors="errors"
                    :value.sync="form.assembly_type"
                    name="assembly_type"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''" >
                <v-flex xs6 md7 lg7>
                  <text-input
                    :form="form"
                    :label="$t('assembly.create-form.description')"
                    autocomplete="assembly_description"
                    :v-errors="errors"
                    :value.sync="form.description"
                    counter="30"
                    name="description"
                    v-validate="'required|max:30'"
                  ></text-input>
                </v-flex>
                <v-flex xs6 md5 lg5>
                  <text-input
                    :form="form"
                    :label="$t('assembly.create-form.responsible_name')"
                    autocomplete="assembly_responsible"
                    :v-errors="errors"
                    :value.sync="form.responsible_name"
                    counter="30"
                    name="responsible_name"
                    v-validate="'required|max:30'"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex md3 lg4>
                  <date-picker
                    :form="form"
                    :label="$t('assembly.create-form.assembly_date')"
                    :v-errors="errors"
                    :value.sync="form.assembly_date"
                    name="assembly_date"
                    v-validate="'required'"
                  ></date-picker>
                </v-flex>
                <v-flex md3 lg4>
                  <time-picker
                    :form="form"
                    :label="$t('assembly.create-form.assembly_time')"
                    :v-errors="errors"
                    :value.sync="form.assembly_time"
                    name="assembly_time"
                    format="24hr"
                    v-validate="'required'"
                  ></time-picker>
                </v-flex>
                <v-flex md5 lg4 >
                  <time-picker
                    v-if="totalFamiliesPortfolioEntered != null"
                    :form="form"
                    :label="$t('assembly.create-form.assembly_finish_time')"
                    :v-errors="errors"
                    :value.sync="form.assembly_finish_time"
                    :min="form.assembly_time"
                    name="assembly_finish_time"
                    format="24hr"
                  ></time-picker>
                  <span v-else>
                    Recuerde que debe Tomar la instantánea de familias en cartera para poder cerrar la asamblea
                  </span>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != 'virtual' && form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Asistencia</h3>
                </v-flex>
                <v-flex md3 lg3>
                    <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_attendance_percentage')"
                    :v-errors="errors"
                    :value.sync="form.min_attendance_percentage"
                    name="min_attendance_percentage"
                    v-validate="`${form.assembly_type != 'virtual' ? 'required' : ''}`"
                  ></number-input>
                </v-flex>
                <v-flex md3 lg3>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_attendance_percentage_asopaf')"
                    :v-errors="errors"
                    :value.sync="form.min_attendance_percentage_asopaf"
                    name="min_attendance_percentage_asopaf"
                    v-validate="`${form.assembly_type != 'virtual' ? 'required' : ''}`"
                  ></number-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type == 'virtual'">
                <v-flex sm4 md3 lg4>
                  <h3>Acceso virtual</h3>
                </v-flex>
                <v-flex xs12 md8 lg8>
                  <text-input
                    v-if="form.assembly_type == 'virtual'"
                    :form="form"
                    :label="$t('assembly.create-form.virtual_meet_link')"
                    autocomplete="assembly_virtual_meet_link"
                    :v-errors="errors"
                    :value.sync="form.virtual_meet_link"
                    counter="100"
                    name="virtual_meet_link"
                    v-validate="`${form.assembly_type == 'virtual' ? 'required|max:100' : ''}`"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex sm4 md3 lg4>
                  <h3>Selección de documentos</h3>
                </v-flex>
                <v-flex xs12 md4 lg4>
                  <select-input
                    :form="form"
                    :label="$t('assembly.create-form.give_power_document_id')"
                    :items="documents_assembly"
                    :v-errors="errors"
                    :value.sync="form.give_power_document_id"
                    name="give_power_document_id"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
                <v-flex xs12 md4 lg4>
                  <select-input
                    :form="form"
                    :label="$t('assembly.create-form.take_power_document_id')"
                    :items="documents_assembly"
                    :v-errors="errors"
                    :value.sync="form.take_power_document_id"
                    name="take_power_document_id"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.assembly_type != ''">
                <v-flex sm4 md3 lg4>
                  <h3>Poderes</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.delegated_powers_limit')"
                    :hint="$t('assembly.create-form.hints.delegated_powers_limit')"
                    persistent-hint
                    autocomplete="delegated_powers_limit"
                    :v-errors="errors"
                    :value.sync="form.delegated_powers_limit"
                    name="delegated_powers_limit"
                    v-validate="'required'"
                  ></number-input>
                </v-flex>
                 <v-flex xs6 md3 lg2>
                  <date-picker
                    :form="form"
                    :label="$t('assembly.create-form.delegated_powers_date_start')"
                    :max="form.assembly_date ? form.assembly_date : null"
                    :v-errors="errors"
                    :value.sync="form.delegated_powers_date_start"
                    name="delegated_powers_date_start"
                    v-validate="'required'"
                  ></date-picker>
                </v-flex>
                <v-flex xs6 md3 lg2>
                  <date-picker
                    :form="form"
                    :label="$t('assembly.create-form.delegated_powers_date_limit')"
                    :min="form.delegated_powers_date_start ? form.delegated_powers_date_start : null"
                    :max="form.assembly_date ? form.assembly_date : null"
                    :v-errors="errors"
                    :value.sync="form.delegated_powers_date_limit"
                    name="delegated_powers_date_limit"
                    v-validate="'required'"
                  ></date-picker>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex sm4 md3 lg4>
                  <h3>Primera convocatoria</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <time-picker
                    :form="form"
                    :label="$t('assembly.create-form.first_call_time')"
                    :v-errors="errors"
                    :value.sync="form.first_call_time"
                    name="first_call_time"
                    format="24hr"
                    :min="form.assembly_time ? form.assembly_time : ''"
                    v-validate="`${form.assembly_type == 'virtual' ? 'required' : ''}`"
                  ></time-picker>
                </v-flex>
                <v-flex md3 lg4>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_percentage_first_call')"
                    persistent-hint
                    :min="0.1"
                    :max="100"
                    :step="0.1"
                    autocomplete="min_percentage_first_call"
                    :v-errors="errors"
                    :value.sync="form.min_percentage_first_call"
                    name="min_percentage_first_call"
                    v-validate="'required|min_value:0.1|max_value:100'"
                  ></number-input>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex sm4 md3 lg4>
                  <h3>Segunda convocatoria</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <time-picker
                    :form="form"
                    :label="$t('assembly.create-form.second_call_time')"
                    :v-errors="errors"
                    :value.sync="form.second_call_time"
                    :min="form.first_call_time ? form.first_call_time : ''"
                    name="second_call_time"
                    v-validate="`${form.assembly_type == 'virtual' ? 'required' : ''}`"
                  ></time-picker>
                </v-flex>
                <v-flex md3 lg4>
                  <number-input
                    :form="form"
                    :label="$t('assembly.create-form.min_percentage_second_call')"
                    :min="0.1"
                    :max="100"
                    :step="0.1"
                    persistent-hint
                    autocomplete="min_percentage_second_call"
                    :v-errors="errors"
                    :value.sync="form.min_percentage_second_call"
                    name="min_percentage_second_call"
                    v-validate="'required|min_value:0.1|max_value:100'"
                  ></number-input>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex sm4 md3 lg4>
                  <h3>Familias en Cartera (instantánea)</h3>
                </v-flex>
                <v-flex md3 lg4>
                  <v-text-field
                    label="Total familias en cartera"
                    :value="totalFamiliesPortfolioEntered"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 lg4>
                  <v-text-field
                    label="Total familias ASOPAF en cartera"
                    :value="totalFamiliesAsopafPortfolioEntered"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 lg4>
                  <v-btn v-if="!assemblyIsClosed && totalFamiliesPortfolioEntered == null" medium @click="capableFamiliesPhotoConfirm = true" dark color="blue ligthen-2"><v-icon class="mr-2">add_a_photo</v-icon> Calcular</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions v-if="form.assembly_type != ''"> 
            <v-spacer></v-spacer>
            <span class='grey--text mr-2'>{{ assemblyIsOnPlay && assemblyIsOnPlayDate ? 'Activo desde' : 'Inactivo desde' }} {{ assemblyIsOnPlayDate ? assemblyIsOnPlayDate.substr(0, 19) : '' }}</span>
            <v-btn v-if="!assemblyIsClosed" :color="assemblyIsOnPlay === 0 ? 'success' : 'warning'" @click="playNStopAssembly">{{ assemblyIsOnPlay === 0 ? $t('assembly.create-form.play-assembly') : $t('assembly.create-form.stop-assembly') }}</v-btn>
            <submit-button v-if="!assemblyIsClosed" :form="form" :label="$t('assembly.create-form.save-button')"></submit-button>
            <v-btn @click="$router.push({ name: 'assembly.show' });" :loading="form.busy">{{ $t('cancel') }}</v-btn>
            <v-btn v-if="!assemblyIsClosed && totalFamiliesPortfolioEntered > 1" medium @click="closeAssemblyConfirm = true" color="warning">Cerrar asamblea</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-flex>
    <v-dialog
      v-model="closeAssemblyConfirm"
      max-width="440"
    >
      <v-card>
        <v-card-title class="title red--text text--darken-2">Cerrar asamblea</v-card-title>
        <v-card-text>
          Al cerrar la asamblea nadie podrá acceder a ella y se tomará una instantánea de los resultados actuales para los reportes.
          <br><br>
          <b>¿Está seguro que desea <span class='red--text'>Cerrar esta Asamblea</span></b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            flat="flat"
            :loading="isLoading"
            @click="closeAssembly"
          >
            Si, Cerrar
          </v-btn>
          <v-btn
            color="grey darken-1"
            flat="flat"
            :loading="isLoading"
            @click="closeAssemblyConfirm = false"
          >
            Cancelar
          </v-btn>

          
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="capableFamiliesPhotoConfirm"
      max-width="440"
    >
      <v-card>
        <v-card-title class="title blue--text text--darken-1">Crear instantánea - Familias inhabilitadas</v-card-title>
        <v-card-text>
          Antes de iniciar la asamblea, deberá calcular el dato de las familias inhabilitadas para el cálculo del Quórum.
          <br><br>
          <b>¿Está seguro que desea <span class='blue--text text--darken-1'>Crear esta instantánea</span></b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :loading="isLoading"
            @click="setCapableCountFamilies"
          >
            Si, Crear instantánea
          </v-btn>
          <v-btn
            color="grey darken-1"
            flat="flat"
            :loading="isLoading"
            @click="capableFamiliesPhotoConfirm = false"
          >
            Cancelar
          </v-btn>

          
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import axios from 'axios'
import Form from 'vform';
import NumberInput from '../../components/form/NumberInput.vue';
import TextInput from '../../components/form/DatePicker.vue';

export default {
  components: { 
    NumberInput, 
    'date-picker': TextInput 
  },
  name: 'assembly-create-view',

  data() {
    return {
      nowDate: new Date().toLocaleDateString('en-CA'),
      assembly_types: [
        { value: 'in_person', text: this.$t('assembly.assembly_types.in_person') },
        { value: 'virtual', text: this.$t('assembly.assembly_types.virtual') },
      ],
      form: new Form({
        assembly_date: '',
        assembly_time: '',
        assembly_finish_time: '',
        assembly_type: '',
        responsible_id: '',
        responsible_name: '',
        description: '',
        delegated_powers_limit: '',
        delegated_powers_date_limit: '',
        delegated_powers_date_start: '',
        min_attendance_percentage: '',
        min_attendance_percentage_asopaf: '',
        virtual_meet_link: '',
        first_call_time: '',
        min_percentage_first_call: 50,
        second_call_time: '',
        min_percentage_second_call: '',
        give_power_document_id: '',
        take_power_document_id: '',
      }),
      documents_assembly: [],
      assemblyIsClosed: false,
      assemblyIsOnPlay: 0,
      assemblyIsOnPlayDate: null,
      closeAssemblyConfirm: false,
      capableFamiliesPhotoConfirm: false,
      totalFamiliesPortfolioEntered: null,
      totalFamiliesAsopafPortfolioEntered: null,
    }
  },
  created() {
    this.getDocumentsForAssembly()
    const idAssembly = this.$route.params.id;
    this.form.idAssembly = idAssembly;
    this.isLoading = true
    axios.get(`/api/assembly/${idAssembly}`)
      .then(response => {
        const { data, status } = response;
        if (status === 200) {
          const { assembly } = data;
          this.nowDate = new Date(response.data.current_time).toLocaleDateString('en-CA')
          this.form.assembly_date = assembly.assembly_date;
          this.form.assembly_time = assembly.assembly_time.slice(0,5);
          this.form.assembly_finish_time = assembly.assembly_finish_time ? assembly.assembly_finish_time.slice(0,5) : null;
          this.form.assembly_type = assembly.assembly_type;
          this.form.responsible_id = assembly.responsible_id;
          this.form.responsible_name = assembly.responsible_name;
          this.form.description = assembly.description;
          this.form.delegated_powers_limit = assembly.delegated_powers_limit;
          this.form.delegated_powers_date_start = assembly.delegated_powers_date_start;
          this.form.delegated_powers_date_limit = assembly.delegated_powers_date_limit;
          this.form.min_attendance_percentage = assembly.min_attendance_percentage;
          this.form.min_attendance_percentage_asopaf = assembly.min_attendance_percentage_asopaf;
          this.form.virtual_meet_link = assembly.virtual_meet_link;
          this.form.first_call_time = assembly.first_call_time.slice(0,5);
          this.form.min_percentage_first_call = assembly.min_percentage_first_call ? new Intl.NumberFormat("en-US").format(assembly.min_percentage_first_call) : null;
          this.form.second_call_time = assembly.second_call_time.slice(0,5);
          this.form.min_percentage_second_call = assembly.min_percentage_second_call ? new Intl.NumberFormat("en-US").format(assembly.min_percentage_second_call) : null;
          this.form.give_power_document_id = assembly.give_power_document_id;
          this.form.take_power_document_id = assembly.take_power_document_id;
          this.totalFamiliesPortfolioEntered = assembly.total_families_portfolio_entered > 0 ? assembly.total_families_portfolio_entered : null;
          this.totalFamiliesAsopafPortfolioEntered = assembly.total_families_portfolio_asopaf_entered > 0 ? assembly.total_families_portfolio_asopaf_entered : null;
          if (assembly.status == 1 || assembly.status == 2) {
            this.assemblyIsClosed = true;
          }
          this.assemblyIsOnPlay = assembly.assembly_is_active === 1 ? 1 : 0
          this.assemblyIsOnPlayDate = assembly.assembly_active_date
        }
        this.isLoading = false
      })
      .catch(error => {
        this.isLoading = false
        console.log(error)
      });
  },
  methods: {



    playNStopAssembly() {
      let context = this
      context.isLoading = true
      let new_status = context.assemblyIsOnPlay === 1 ? 0 : 1
      axios.post(`/api/assembly/play_stop/${context.form.idAssembly}/${new_status}`)
        .then(resp => {
          if (resp.status === 200) {
            context.isLoading = false
            context.assemblyIsOnPlay = new_status
            context.$store.dispatch('responseMessage', {
              type: 'success',
              text: `La asamblea ${context.assemblyIsOnPlay === 0 ? 'se ha detenido' : 'ha iniciado' }`,
              title: "Exitoso",
              modal: false
            })
            context.assemblyIsOnPlayDate = resp.data['date'];
          } else {
            context.isLoading = false
            context.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'Hubo un error activando/desactivando la asamblea',
              title: 'Error',
              modal: true
            })
          }
        })
    },

    async editAssembly() {
      this.isLoading = true
      if (await this.formHasErrors()) return

      const result = await this.form.put('/api/assembly')

      if (result.status === 200) {
        this.isLoading = false
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('assembly.edit-form.stored-ok-text'),
          title: this.$t('assembly.edit-form.stored-ok-title'),
          modal: true
        })
        this.$router.push({ name: 'assembly.show' });
      }
    },
    

    async editAssembly() {
      this.isLoading = true
      if (await this.formHasErrors()) return

      const result = await this.form.put('/api/assembly')

      if (result.status === 200) {
        this.isLoading = false
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('assembly.edit-form.stored-ok-text'),
          title: this.$t('assembly.edit-form.stored-ok-title'),
          modal: true
        })
        this.$router.push({ name: 'assembly.show' });
      }
    },
    setCapableCountFamilies(){
      let payload = { id: this.form.idAssembly }
      axios.post(`/api/assembly/capable_count_families`, payload)
        .then(res => {
          this.totalFamiliesPortfolioEntered = res.data.total_families_portfolio_entered
          this.totalFamiliesAsopafPortfolioEntered = res.data.total_families_portfolio_asopaf_entered
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: `Instantánea creada, con ${this.totalFamiliesPortfolioEntered} inhabilitadas familias por cartera para esta Asamblea`,
          })
          this.capableFamiliesPhotoConfirm = false;
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    getDocumentsForAssembly(){
      let context = this
      context.isLoading = true
      axios.get(`/api/documents/get_documents_for_assembly`)
        .then(res => {
          res.data.forEach(document => {
            context.documents_assembly.push({ value: document.id, text: `${document.id} - ${document.description}` })
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    closeAssembly() {
      const idAssembly = this.$route.params.id;
      axios.post('/api/assembly/close', { idAssembly })
        .then(response => {
          if (response.status === 200) {
            this.assemblyIsClosed = true;
            this.closeAssemblyConfirm = false;
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: `¡Asamblea cerrada correctamente!`,
            })
          }
        })
        .catch(error => {
          console.log(error);
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/edit.vue